import React, { Component } from "react";
import { Message, Segment, Button, Divider } from "semantic-ui-react";
import request from "../../utils/request";
import { AppContext } from "../../utils/context";

class SettingsBitmask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      selectedFile: null,
      response: {
        url: '',
        name: '',
        message: '',
        status: ''
      }
    };
  }
  componentDidMount = () => {
    this.doneLoading();
  };
  doneLoading = () => {
    this.setState({ isLoading:false });
  }
  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  };
  // On file select (from the pop up)
  onFileChange = event => {
    
    // Update the state
    this.setState({ selectedFile: event.target.files[0] });
  
  };
  // On file upload (click the upload button)
  onFileUpload = () => {
    
    // Create an object of formData
    const formData = new FormData();
  
    // Update the formData object
    formData.append("file", this.state.selectedFile);
    formData.append("filename", this.state.selectedFile.name);
  
    // Request made to the backend api
    // Send formData object
    request.post(this, "api:/upload-bitmask", formData).then(resp => {
      this.setState({
        response: {
          url: resp.data && resp.data.url !== '' ? resp.data.url : '',
          name: resp.data && resp.data.name !== '' ? resp.data.name : '',
          message: resp.message,
          status: resp.status
        }
      });
    });
  };
  // File content to be displayed after
    // file upload is complete
    fileData = () => {
      if (this.state.selectedFile && this.state.response.status === '') {
        return (
          <div>
            <br />
            <h2>File Details:</h2>
            <p>File Name: {this.state.selectedFile.name}</p>
          </div>
        );
      }
    };
  render() {
    const {
      isLoading,
      response
    } = this.state;
    return (
      <Segment basic loading={isLoading}>
        {response.status === "error" &&
          <Message negative hidden={response.status==="success"}>
            <p>{response.message}</p>
          </Message>
        }
        {response.status === "success" &&
          <Message positive hidden={response.status==="error"}>
            <p>{response.message}</p>
          </Message>
        }
          <div>
            {this.context && this.context.settings && this.context.settings.web && this.context.settings.web.bitmask_url !== "" &&
              <div><label>Looks like there is an active bitmask in use. If you wish to overwrite it, follow the instructions below.</label><br /><br /></div>
            }
            <label>Please upload the output file generated from executing the BitMapParser application.</label>
            <Divider></Divider>
            <Button><input type="file" onChange={this.onFileChange} /></Button>
            {this.state.selectedFile && <Button onClick={this.onFileUpload} primary={true}>
              Upload
            </Button>}
          </div>
        {this.fileData()}
      </Segment>
    );
  }
}

SettingsBitmask.contextType = AppContext;

export default SettingsBitmask;
